import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { waLink } from "../data/content";
import { useT } from "../i18n";

const FloatingWhatsApp = () => {
  const t = useT();
  return (
    <motion.a
      data-testid="floating-whatsapp-button"
      href={waLink(t.wa.generic)}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with CRESSCO on WhatsApp"
      initial={{ opacity: 0, scale: 0.6 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 1.6, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
      className="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_10px_32px_rgba(37,211,102,0.4)] transition-transform duration-300 hover:scale-110"
    >
      <span className="absolute inset-0 animate-ping rounded-full bg-[#25D366]/30" />
      <MessageCircle size={26} className="relative" />
    </motion.a>
  );
};

export default FloatingWhatsApp;
